export const BUY_IT_AGAIN = {
    label: 'Buy It Again',
    value: 'EASY_REORDER',
};
export const PERSONALIZED_RECOMMENDATIONS = {
    label: 'Personalized Recommendations',
    value: 'RECOMMENDATIONS',
};
// Omitted from type array for now
export const PLUS_MEMBERSHIP_DEALS = {
    label: 'Plus Membership Deals',
    value: 'PLUS_MEMBERSHIP_DEALS',
};

export const DYNAMIC_AISLE_TYPES = [BUY_IT_AGAIN, PERSONALIZED_RECOMMENDATIONS];
